export default [
  {
    name: 'InsightModels',
    path: '/insight-models',
    component: () => import('./pages/InsightModels'),
    meta: {
      ability: [
        {
          resource: 'insight-models',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add InsightModel',
    path: '/insight-models/add',
    component: () => import('./pages/InsightModelsDetails'),
    meta: {
      ability: [
        {
          resource: 'insight-models',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit InsightModel',
    path: '/insight-models/edit/:organizationId',
    component: () => import('./pages/InsightModelsDetails'),
    meta: {
      ability: [
        {
          resource: 'insight-models',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
